import { render, staticRenderFns } from "./e-model-cash-register-address.vue?vue&type=template&id=1c1e2311&scoped=true&lang=pug&"
import script from "./e-model-cash-register-address.vue?vue&type=script&lang=js&"
export * from "./e-model-cash-register-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e2311",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
